import CryptoJS from 'crypto-js';

const KEY = '8f3dA9kL2pQ7xZrT5vNw1YcH6uB4mE0J';

// 加密
export function encrypt(text) {
	return CryptoJS.AES.encrypt(text, KEY).toString();
}

// 解密
export function decrypt(ciphertext) {
	const bytes = CryptoJS.AES.decrypt(ciphertext, KEY);
	return bytes.toString(CryptoJS.enc.Utf8);
}
